import {
  FC,
  PropsWithChildren,
  ReactNode,
  useEffect,
  useRef,
  useState
} from 'react'
import clsx from 'clsx'
import { off, on } from '@/utils/evenListening'
import styles from './index.module.sass'

export type FunctionChildren = (isSticky: boolean) => ReactNode;
interface Props {
  children?: FunctionChildren | ReactNode;
}

const StickyBanner: FC<PropsWithChildren<Props>> = ({ children }) => {
  const [isSticky, setSticky] = useState(false)
  const stickyRef = useRef<HTMLDivElement>(null)
  const fullHeight = useRef(0)

  useEffect(() => {
    const stickyInstance = stickyRef.current
    if (!stickyInstance) return

    const header = stickyInstance.getBoundingClientRect()
    const handleScroll = () => {
      if (window.scrollY > header.top + header.height) {
        setSticky(true)
      } else {
        setSticky(false)
      }
    }

    on(window, 'scroll', handleScroll)
    fullHeight.current = header.height
    return () => {
      off(window, 'scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <div
        className={clsx(styles.stickyBanner, isSticky ? styles.sticky : '')}
        ref={stickyRef}
      >
        <div className={styles.stickyBannerContent}>
          {typeof children === 'function' ? children(isSticky) : children}
        </div>
      </div>
      {isSticky ? <div style={{ height: `${fullHeight.current}px` }} /> : <></>}
    </>
  )
}

export default StickyBanner
